import React, { Fragment } from 'react'
import { Button, Menu, MenuButton, MenuList } from '@chakra-ui/react'
import { DotsIcon } from '../Icon'
import { OptionMenuProps } from './interface'

const OptionMenu: React.FC<OptionMenuProps> = ({ items }) => {
  return (
    <Menu placement="bottom-end">
      <MenuButton as={Button} variant="clean">
        <DotsIcon />
      </MenuButton>
      <MenuList>
        {items.map((elm, index) => (
          <Fragment key={index}>{elm}</Fragment>
        ))}
      </MenuList>
    </Menu>
  )
}

export default OptionMenu
